import angular from 'angular';
import verifyComponent from './verify.component';
import SignatureVerify from './signature-verify/signature-verify';
import EvidenceValidation from './evidence-validation/evidence-validation';

import formTpl from './verify.form.html';
import mainTpl from './verify.main.html';
import resultTpl from './verify.result.html';
import errorTpl from './verify.error.html';

let verifyModule = angular.module('verify', [SignatureVerify.name,EvidenceValidation.name])

    .component('verify', verifyComponent)

    .name;

let states = [
    {
        name: 'verify',
        abstract: true,
        component: 'verify',
        onExit: ($transition$) => {
            'ngInject';
            if ($transition$.to().name === 'app.face.index.user.form.login') {
                var params = $transition$.params();
                var $state = $transition$.router.stateService;
                if (!params.return) {
                    return $state.target($transition$.to(), {
                        return: encodeURI(location.href)
                    });
                }
            }
        }
    },
    {
        name: 'verify.main',
        abstract: true,
        url: '/verify',
        template: mainTpl
    },
    {
        name: 'verify.main.form',
        url: '/dna',
        template: formTpl,
        title: 'page-verify-title'
    },
    {
        name: 'verify.result',
        url: '/verify/result',
        template: resultTpl
    },
    {
        name: 'verify.error',
        url: '/verify/error',
        template: errorTpl
    }
];

SignatureVerify.states.forEach((m) => {
    m.name = 'verify.main.' + m.name;
    states.push(m)
})
EvidenceValidation.states.forEach((m) => {
    m.name = 'verify.main.' + m.name;
    states.push(m)
})

export default {name: verifyModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/verify/verify.js